module.exports = __webpack_public_path__ + "static/media/customize.6662dcc6.svg";